import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayBlockConfirmedPayload {
  shiftId: string;
  professionalId?: string;
}

/**
 * Fires when an office confirms the block from the block confirmation pop-up
 * within the end-of-day flow.
 * Event: dental_portal:end_of_day:block_confirmed
 */
export function fireEndOfDayBlockConfirmed(payload: IEndOfDayBlockConfirmedPayload): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:block_confirmed', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
  });
}
